import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: 'app-delete-attachment-warning',
    templateUrl: './delete-attachment-warning.component.html',
    styleUrls: ['./delete-attachment-warning.component.scss'],
    standalone: false
})
export class DeleteAttachmentWarningComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<DeleteAttachmentWarningComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {
  }
  cancel(){
    this.dialogRef.close(false);
  }
  deleteProjectAttachment() {
    this.dialogRef.close(true);
  }

}
